"use client";
import React from "react";
import TextInput from "./form-components/TextInput";
import SelectInput from "./form-components/SelectInput";
import MultiSelect from "./form-components/MultiSelect";
import Switch from "./form-components/Switch";
import Checkbox from "./form-components/Checkbox";
import { useFormContext } from "./context/FormContext";
import ButtonSimple, { ButtonOutline } from "@/components/ui/button-simple";

const productCategories = [
  { label: "Laptops", value: "laptops" },
  { label: "Tablets", value: "tablets" },
  { label: "Smartphones", value: "phones" },
  { label: "Gaming Consoles", value: "gaming" },
  { label: "Cameras", value: "cameras" },
  { label: "Audio Devices", value: "audio" },
  { label: "Smart Home Devices", value: "smarthome" },
  { label: "Wearables", value: "wearables" },
];

const purchaseTimelines = [
  { label: "Once a week", value: "once-weekly" },
  { label: "A few times a month", value: "few-times-monthly" },
  { label: "Once a month", value: "once-monthly" },
  { label: "Every few months", value: "every-few-months" },
  { label: "Rarely", value: "rarely" },
];

const BuyingProfilePersonal = () => {
  const { personalMethods, handleBack, handleFormSubmit, submitError } = useFormContext();
  const { register, formState, watch, setValue } = personalMethods;

  return (
    <form
      onSubmit={personalMethods.handleSubmit(data => handleFormSubmit(data, "personal"))}
      className="mt-8 space-y-4"
    >
      <TextInput
        label="Personal email"
        type="email"
        {...register("personalEmail")}
        error={formState.errors.personalEmail?.message}
        placeholder="Enter your email"
      />

      <MultiSelect
        label="Preferred product categories"
        value={watch("productCategories") || []}
        onValueChange={value => setValue("productCategories", value, { shouldValidate: true })}
        error={formState.errors.productCategories?.message}
        options={productCategories}
        placeholder="Select product categories"
      />

      <div className="pb-4 pt-4">
        <p className="mb-4 text-[15px] font-medium text-system-disabled">
          Share your notification preferences and future purchasing plans
        </p>

        <div>
          <p className="mb-[11px] text-sm text-system-titanium">Preferred notification method</p>
          <div className="flex gap-12">
            <Switch
              id="email-notifications"
              label="E-mail"
              checked={watch("notificationPreferences.email")}
              onCheckedChange={checked => setValue("notificationPreferences.email", checked)}
            />
            <Switch
              id="sms-notifications"
              label="SMS"
              checked={watch("notificationPreferences.sms")}
              onCheckedChange={checked => setValue("notificationPreferences.sms", checked)}
            />
          </div>
        </div>
      </div>

      <SelectInput
        label="How frequently do you plan to make a purchase?"
        value={watch("purchaseTimeline")}
        onChange={value => setValue("purchaseTimeline", value, { shouldValidate: true })}
        error={formState.errors.purchaseTimeline?.message}
        options={purchaseTimelines}
        placeholder="Select timeline"
      />

      <div className="pt-4">
        <Checkbox
          id="privacy-policy"
          checked={watch("privacyPolicy")}
          onCheckedChange={checked => setValue("privacyPolicy", checked, { shouldValidate: true })}
          error={formState.errors.privacyPolicy?.message}
          label={
            <>
              I confirm that I have read and agree to the{" "}
              <a href="/privacypolicy" target="_blank" className="text-system-primary">
                Privacy Policy
              </a>
            </>
          }
        />
      </div>

      <div className="flex gap-2.5 pt-2">
        <span>
          <ButtonOutline type="button" onClick={handleBack} className="h-[42px]">
            Go back
          </ButtonOutline>
        </span>
        <span>
          <ButtonSimple type="submit" className="h-[42px] rounded-lg text-white transition-colors">
            Join the waitlist
          </ButtonSimple>
        </span>
      </div>

      {submitError ? (
        <div className="mt-6 text-base font-medium text-red-500">{submitError}</div>
      ) : null}
    </form>
  );
};

export default BuyingProfilePersonal;
